
// https://en.wikipedia.org/wiki/Batted_ball#By_trajectory
// https://library.fangraphs.com/pitching/batted-ball/
const BattedBallType = {
    // http://m.mlb.com/glossary/advanced-stats/ground-ball-rate
    GroundBall: { key: 'GB', name: 'Ground ball', shortName: 'GB', description: 'A grounder is a batted ball that is hit at a low enough trajectory that it hits the ground a short distance after being hit.' },
    // http://m.mlb.com/glossary/advanced-stats/line-drive-rate
    LineDrive: { key: 'LD', name: 'Line drive', shortName: 'LD', description: 'Batted ball hit into the air that travels with a relatively flat trajectory ("on a line").'},
    // http://m.mlb.com/glossary/advanced-stats/fly-ball-rate
    FlyBall: { key: 'FB', name: 'Fly ball',  shortName: 'FB', description: 'A fly ball is a fly to the outfield.'},
    // http://m.mlb.com/glossary/advanced-stats/pop-up-rate
    PopUp: { key: 'PU', name: 'Pop up', shortName: 'PO', description: 'A pop-up (or infield fly) is hit to the infield.'},

    Unidentified: { key: 'UI', name: 'Unidentified', shortName: 'UI', description: 'Unidentified type' },
};

export default BattedBallType;